import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, Card, CardContent, Typography, Button, CircularProgress, GroupAddOutlined } from '@mui/material';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/system';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const API_URL = process.env.REACT_APP_API_URL;

const infoTextStyle = {
  fontSize: { xs: '0.8rem', sm: '1rem' },
  color: '#ccc',
  letterSpacing: 1.5,
  marginTop: 0.5,
};

const viewButtonStyle = {
  fontSize: { xs: '1rem', sm: '1.1rem' },
  padding: '10px 20px',
  letterSpacing: 2,
  borderRadius: '8px',
  backgroundImage: 'linear-gradient(45deg, #2196F3, #1976D2)',
  boxShadow: 3,
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundImage: 'linear-gradient(45deg, #1976D2, #2196F3)',
    boxShadow: 6,
    transform: 'scale(1.05)',
  },
};

const RequestToUsers = ({ userId, onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const { id } = useParams(); // Assuming you use params for teacher ID or some other context
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/get_requests_for_student/`, {
        params: { student_id: userId },
      })
      .then((response) => {
        setRequests(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching requests:', error);
        setLoading(false);
      });
  }, [userId]);

  const handlePayment = (requestId) => {
    
  };

  return (
    <Box sx={{
      padding: { xs: 2, sm: 3, md: 4 },
      backgroundColor: '#000000',
      textAlign: 'center',
      minHeight: '100vh',
    }}>
      {loading ? (
        <CircularProgress sx={{ display: 'inline-block', marginTop: '50px', color: '#fff' }} />
      ) : (
        <Grid container spacing={{ xs: 7, sm: 10, md: 13, lg: 15 }} justifyContent="center">
          {requests.length > 0 ? (
            requests.map((request) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={2}
                key={request.id}
              >
                <Link to={`/request-to-user-tab-details/${request.id}/${request.teacher_id}`} style={{ textDecoration: 'none' }}>
                  <StyledCard
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      padding: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        component="h1"
                        sx={{
                          fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' },
                          fontWeight: 'bold',
                          color: '#fff',
                          letterSpacing: 2,
                          mb: 1,
                          textAlign: 'center',
                        }}
                      >
                        {request.topic.length > 20 ? `${request.topic.substring(0, 20)}...` : request.topic}
                      </Typography>
                      <Typography sx={infoTextStyle}>
                        📅 Date: {request.date} | 🕒 Time: {request.time}
                      </Typography>
                      <Typography sx={infoTextStyle}>
                        🗣️ Language: {request.language}
                      </Typography>
                     
                      <Typography sx={infoTextStyle}>
                        ⏱️ Duration: {request.duration} minutes
                      </Typography>
                      <Typography sx={infoTextStyle}>
                        🚦 Status: {request.status || 'Pending'}
                      </Typography>

                      {request.status === 'Accepted' && (
                        <StyledButton
                        variant="contained"
                        color="primary"
                        fullWidth
                        
                        sx={{
                          fontWeight: 500,
                          letterSpacing: 2,
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                        }}
                        >
                          Confirm Now
                        </StyledButton>
                      )}
                    </CardContent>


                    <Box sx={{ mt: 2 }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        component={Link}
                        to={`/request-to-user-tab-details/${request.id}/${request.teacher_id}`}
                        sx={{
                          fontWeight: 500,
                          letterSpacing: 2,
                          mb: request.status === 'Accepted' ? 1 : 0,
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                          borderColor: '#2196F3',
                          color: '#2196F3',
                          '&:hover': {
                            backgroundColor: '#2196F3',
                            color: '#fff',
                          },
                        }}
                      >
                        View
                      </Button>
                    </Box>
                  </StyledCard>
                </Link>
              </Grid>
            ))
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '3rem',
                color: 'text.secondary',
              }}
            >
              <GroupAddIcon sx={{ fontSize: 50, mb: 2, color: '#ccc' }} />
              <Typography
                variant="h6"
                sx={{
                  textAlign: 'center',
                  color: '#ccc',
                  letterSpacing: 2,
                  maxWidth: 500,
                  mb: 1,
                }}
              >
                Hey, you haven't requested any users for a session yet!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textAlign: 'center',
                  color: '#aaa',
                  fontSize: '1rem',
                  maxWidth: 500,
                  letterSpacing: 2,
                }}
              >
                Explore recommended verified users and send session requests based on your interests.
              </Typography>
            </Box>
          )}
        </Grid>
      )}
    </Box>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: '100%',  // Ensures cards are responsive across breakpoints
  minWidth: '300px', // Add your desired minimum width here
  boxShadow: theme.shadows[5],
  borderRadius: 8,
  background: '#111111', // Dark background for card
  margin: '0 auto',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: theme.shadows[15],
    transition: 'all 0.3s ease-in-out',
  },
  transition: 'all 0.3s ease-in-out',
}));


const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#00796b',
  color: 'white',
  borderRadius: 5,
  '&:hover': {
    backgroundColor: '#004d40',
  },
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1.5),
  boxShadow: theme.shadows[2],
}));

export default RequestToUsers;
